import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-side-nav-dropdown',
  templateUrl: './side-nav-dropdown.component.html',
  styleUrls: ['./side-nav-dropdown.component.scss'],
})

export class SideNavDropdownComponent implements OnInit, OnChanges {
  @Input() label = '';
  @Input() icon = '';
  @Input() open = false;
  @Input() itens = [];
  size = 0;
  @Output() openChange = new EventEmitter();
  usuario:any = "";

  constructor(private loginService: LoginService) { }

  ngOnInit() {
    this.usuario = this.loginService.decodeToken(this.loginService.getTokenLogin());

    if((this.usuario.unidade.id != 1) || !this.usuario.permissoes.administrador){
      this.itens = this.itens.filter(obj => obj.label != "Tipos de unidades");
      this.itens = this.itens.filter(obj => obj.label != "Nova associação de auditoria");
    }

    this.itens = this.itens.filter(obj => obj.label != "Unidades auditadas");
  }
  
  ngOnChanges() {
    this.setMaxSize();
  }

  toggle() {
    this.open = !this.open;
    this.openChange.emit(this.open);
    this.setMaxSize();
  }

  setMaxSize() {
    this.size = this.open ? this.itens.length * 35 + 15 : 0;
  }

}
